module.exports = __webpack_public_path__ + "img/bount-jouez.6c7c0f3c.jpg";